import { createContext, useContext } from "react";

import type { Me } from "./api";

const SessionContext = createContext<Me | null>(null);

export const SessionProvider = SessionContext.Provider;

/** Signed-in identity from `GET /api/me`; `null` until it resolves. */
export function useSession(): Me | null {
  return useContext(SessionContext);
}
